module.exports = __webpack_public_path__ + "img/estoque-vendido.a579b118.svg";